import { render, staticRenderFns } from "./AccidentIntakeSocialFamilyHistoryForm.vue?vue&type=template&id=13216bd2"
import script from "./AccidentIntakeSocialFamilyHistoryForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeSocialFamilyHistoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports